// export default [
//     "Arkansas",
//     "Austin",
//     "Central Texas",
//     "DFW",
//     "East Texas",
//     "Houston",
//     "Louisiana",
//     "Oklahoma",
//     "San Antonio",
//     "Valley",
//     "West Texas"
// ]
export default [
	{ code: "Arkansas", name: "Arkansas" },
	{ code: "California - Central", name: "California - Central" },
	{ code: "California - Northern", name: "California - Northern" },
	{ code: "California - Southern", name: "California - Southern" },
	{ code: "Louisiana", name: "Louisiana" },
	{ code: "Oklahoma", name: "Oklahoma" },
	{ code: "Other", name: "Other" },
	{ code: "Austin", name: "Texas - Austin" },
	{ code: "Central Texas", name: "Texas - Central" },
	{ code: "DFW", name: "Texas - DFW" },
	{ code: "East Texas", name: "Texas - East" },
	{ code: "Houston", name: "Texas - Houston" },
	{ code: "San Antonio", name: "Texas - San Antonio" },
	{ code: "Valley", name: "Texas - Valley" },
	{ code: "West Texas", name: "Texas - West" },
  ];